<template>
    <Link
        :href="link"
        :class="[
            'bb-nav-link linky anim bg-primary-light text-gray-100 relative mx-1 flex w-full flex-col items-center justify-center whitespace-nowrap px-7 py-0 font-normal',
            { active: $page.component === component },
        ]"
    >
        <img
            v-if="icon"
            :src="getIcon()"
            class="icon z-20 h-6 w-6 origin-center"
            aria-hidden="true"
            alt="l.label"
        />
        <img
            v-if="icon"
            :src="getIcon()"
            class="z-10 mb-2 h-2 w-10 origin-center shadow"
            aria-hidden="true"
            alt="l.label"
        />
        <div class="label pl-0 text-center text-sm font-bold uppercase">
            {{ label }}
        </div>
    </Link>
</template>

<script>
import { Link } from '@inertiajs/vue3';

export default {
    name: 'BasketballNavigationLink',
    components: { Link },
    props: ['link', 'label', 'icon', 'component'],
    computed: {},
    data() {
        return {};
    },
    mounted() {},
    methods: {
        getIcon() {
            if (this.icon?.indexOf('http') > -1) {
                return this.icon;
            } else {
                return `/images/icons/${this.icon}`;
            }
        },
    },
};
</script>
<style lang="css">
.bb-nav-link {
    transition: all 0.35s cubic-bezier(0.075, 0.82, 0.165, 1);
    box-shadow: inset 4px 4px 6px rgba(100, 100, 100, 0.1);
    border-radius: 15px;
    position: relative;
    height: 45px;
    margin-top: 16px;
}
.bb-nav-link .label {
    text-shadow:
        -2px -2px 2px rgba(0, 0, 0, 0.7),
        2px 2px 2px rgba(0, 0, 0, 0.7);
}
.bb-nav-link .icon {
    transition: transform 0.35s cubic-bezier(0.075, 0.82, 0.165, 1);
    transform: rotate(0) translateY(-4px);
}
.bb-nav-link .shadow {
    position: absolute;
    bottom: 16px;
    transition: all 0.35s cubic-bezier(0.075, 0.82, 0.165, 1);
    filter: brightness(0) blur(2px);
    opacity: 0;
}

.bb-nav-link:hover,
.bb-nav-link.active {
    background-color: hsl(33, 80%, 66%);
    box-shadow:
        inset 3px 3px 4px rgba(0, 0, 0, 0.5),
        inset -2px -2px 4px rgba(20, 20, 20, 0.4);
}
.bb-nav-link:hover .icon,
.bb-nav-link.active .icon,
.bb-nav-link:hover .icon {
    transform: scale(1.8) rotate(5deg) translateY(-2px);
}
.bb-nav-link:hover .shadow,
.bb-nav-link.active .shadow,
.bb-nav-link:hover .shadow {
    transform: rotate(5px) translateY(40px) scaleX(2);
    filter: brightness(0) blur(4px);
    opacity: 0.3;
}
.bb-nav-link:hover .label,
.bb-nav-link.active .label,
.bb-nav-link:hover .label {
    color: rgba(0, 0, 0, 0.8);
    text-shadow:
        -1px -1px 2px rgba(250, 250, 250, 0.7),
        1px 1px 2px rgba(250, 250, 250, 0.7);
}
</style>
